import { ArrowUpRight, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PRIMARY_NAV, SITE } from "@/config/site";

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? "site-header-scrolled" : ""}`} data-testid="site-header">
      <div className="header-inner">
        <Link to="/" className="brand-link" onClick={closeMenu} data-testid="header-logo-link">
          <img src={SITE.assets.logo} alt="Vmemoo" className="brand-logo" />
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation">
          {PRIMARY_NAV.map((item) => (
            <a key={item.id} href={item.href} data-testid={`header-${item.id}-link`}>{item.label}</a>
          ))}
        </nav>
        <a className="header-cta" href="/#download" data-testid="header-get-vmemoo-link">
          Get Vmemoo <ArrowUpRight size={16} aria-hidden="true" />
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          onClick={() => setMenuOpen((open) => !open)}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
        </button>
      </div>
      {menuOpen && (
        <nav className="mobile-nav" id="mobile-navigation" aria-label="Mobile navigation">
          {PRIMARY_NAV.map((item) => (
            <a key={item.id} href={item.href} onClick={closeMenu} data-testid={`mobile-${item.id}-link`}>{item.label}</a>
          ))}
          <a href="/#download" onClick={closeMenu} data-testid="mobile-get-vmemoo-link">Get Vmemoo <ArrowUpRight size={16} aria-hidden="true" /></a>
        </nav>
      )}
    </header>
  );
}
